module.exports = __webpack_public_path__ + "3fb1e57ca4c8dcfb83f9f3aa08e2d8f3.svg";